import "./RemoveCompletedItems.scss";

function RemoveCompletedItems({
  cancelRemoveCompletedItems,
  removeCompletedItems,
  completedCount,
}) {
  return (
    <div className="remove-completed-items-content">
      <div className="modal-title">
        <div>Remove Completed Items</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete {completedCount} completed {completedCount === 1 ? 'item' : 'items'}?</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveCompletedItems}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeCompletedItems}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveCompletedItems;
